import { axiosInstance } from '~/common/utils/api.util';

import type { ApiResponse } from '~/common/types/api.type';
import type { Inquiry } from '~/features/inquiry/types/inquiry.type';

/**
 * 문의 상세 조회
 * @endpoint GET /admin/inquiries/:id
 */
export function getInquiryApi(id: number) {
  return axiosInstance.get<ApiResponse<Inquiry>>(`/admin/inquiries/${id}`);
}
